import { getPageAllowedRoles } from "../../config/roles";
import { validateSendWindowEnd, validateSendWindowStart } from "../communication/sendWindow";
import { RecordDefinition } from "../recordDefinition.types";
import { communicationSettingsPageConfig } from "./communicationSettingsPageConfig";
import { ActivationNotice, CustomerId } from "./activationFields";

// The same pattern as js/utility's isValidEmail, which drags the service layer in.
const EmailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const isActivated = (record: Record<string, unknown>) =>
  Boolean(record.g4c_customerid);

export const communicationSettingsRecordDefinition: RecordDefinition = {
  path: "/communication-settings",
  entityName: "g4c_communicationoptions",
  listRoute: "/settings",
  backTitle: "Back to settings",
  allowedRoles: getPageAllowedRoles("communication-settings"),
  config: communicationSettingsPageConfig,
  // One record per organisation, laid out here and nowhere else.
  authorable: false,
  readMethod: "GetCommunicationOptions",
  fieldComponents: {
    communicationActivationNotice: ActivationNotice,
    communicationCustomerId: CustomerId,
  },
  recordAdapter: (record) => ({
    ...record,
    g4c_defaultrunat: record.g4c_defaultrunat || "crm",
  }),
  identity: {
    titleFields: [],
    fallbackTitle: "Communication Settings",
    newRecordTitle: "Communication Settings",
  },
  editableWhen: "isActivated",
  visibilityRules: {
    isActivated,
    notActivated: (record) => !isActivated(record),
    warehouseAudienceEnabled: (_, config) =>
      Boolean(config.WarehouseCommunicationAudienceEnabled),
  },
  fieldValidators: {
    communicationFromAddress: (value) =>
      typeof value === "string" && EmailPattern.test(value)
        ? ""
        : "Please enter a valid email address",
    communicationSendWindowStart: (value, record) =>
      validateSendWindowStart(value, record, "g4ca_sendwindowend"),
    communicationSendWindowEnd: (value, record) =>
      validateSendWindowEnd(value, record, "g4ca_sendwindowstart"),
  },
};
